function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyChooseUsFirstPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.17,106.52l77.78-.11s-3.88-5-8.14-5.66c0,0-8.33-24.67-22.21-24.82-12.91-.15-18.06,15.21-18.06,15.21s-6-6.88-11.7-3.72-8.93,12.17-8.93,12.17S390.49,103.06,388.17,106.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.68,120.5l-98.36.15s0-6.29,13.54-7.54c0,0,12.33-27.48,31.22-23.82,11.77,2.28,17.8,18.42,17.8,18.42s8.87-12.72,16-10.27,11.35,16,11.35,16S221.56,117,222.68,120.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.57,192.42l-66.88.1s6.31-5.88,9.11-5.88,11-19.74,21.43-18.92,16,15.5,16,15.5S363,179.22,370.57,192.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.25,174l-57.2.09s2.84-3.71,6-4.17c0,0,6.06-18.16,16.27-18.31,9.49-.13,13.31,11.14,13.31,11.14s4.39-5.06,8.6-2.76,6.59,8.93,6.59,8.93S89.53,171.42,91.25,174Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "29.43 423.96 84.57 423.72 139.72 423.63 250 423.46 360.29 423.63 415.43 423.72 470.57 423.96 415.43 424.2 360.29 424.29 250 424.46 139.72 424.29 84.57 424.2 29.43 423.96",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.47,
    cy: 446.06,
    rx: 182.98,
    ry: 17.77,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sun--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.53,80.93a42,42,0,0,1-42,42c-23.21,0-43.07-18.81-43.07-42S75.3,37.86,98.51,37.86,140.53,57.72,140.53,80.93Z",
    style: {
      fill: "#62CE71"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.55,115.25A34.42,34.42,0,0,1,63.14,80.84c0-19,15.41-35.28,34.41-35.28s35.28,16.27,35.28,35.28S116.56,115.25,97.55,115.25Z",
    style: {
      fill: "#62CE71"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 98.43,
    cy: 80.85,
    r: 29.35,
    style: {
      fill: "#62CE71"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.35,392.88l-4.43,50.21h119s-13.29-100.38-13.29-101.26,24.21-31.59,18.9-96.84C296.89,163.78,240,135.76,182.76,135.76s-97.42,52.91-103,90.66l-21,85,27.45,3.84s1.18,57.56,16,72.32S183.35,392.88,183.35,392.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.35,392.88l-4.43,50.21h119s-13.29-100.38-13.29-101.26,24.21-31.59,18.9-96.84C296.89,163.78,240,135.76,182.76,135.76s-97.42,52.91-103,90.66l-21,85,27.45,3.84s1.18,57.56,16,72.32S183.35,392.88,183.35,392.88Z",
    style: {
      fill: "#62CE71",
      opacity: 0.41000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.75,247.27c-2.2,10.08-15.56,15-15.56,15-.82,1.82,3.73,37.37,5,39.4s-6.25,7.27-7.24,6.1-9.78-24.3-28.07-28.46h0a29.93,29.93,0,0,1-22.21,10.27c-14.7.36-25.4-10.16-25.4-10.16s-10.37,15.3-32.11,11.35-26.35-21.1-26.35-21.1-28.09,8.49-38.88-14.48c-8.26-17.57.8-30.37,5.48-35.38a24.66,24.66,0,0,1,2.42-2.33h0s-2.32-21.31,10.85-32.48,30.56-9.83,30.56-9.83,7-21.57,27.13-25.77,32.32,7.47,32.32,7.47a47.52,47.52,0,0,1,38-.2c20.9,8.71,20.26,29.47,20.26,29.47s15.2,5,20.24,17.41-3.2,24.86-3.2,24.86S288.94,237.19,286.75,247.27Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.88,279.3h0a29.93,29.93,0,0,1-22.21,10.27c-14.7.36-25.4-10.16-25.4-10.16s-10.37,15.3-32.11,11.35-26.35-21.1-26.35-21.1-28.09,8.49-38.88-14.48c-8.26-17.57.8-30.37,5.48-35.38l2.42-2.33h0c-.13.36-7.82,21.78,5.82,35.19S143,257.34,143,257.34s2.52,21.2,19.42,26.05c18.77,5.39,30.94-8.88,30.94-8.88S215.31,298.42,240.88,279.3Z",
    style: {
      fill: "#222221",
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269,307.76c-1-1.16-9.78-24.3-28.07-28.46,0,0,15-8.81,21.91-2.64S269,307.76,269,307.76Z",
    style: {
      fill: "#222221",
      opacity: 0.1,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,140.54c1.07-.6,2.82-1.46,4.08-1.22a1.46,1.46,0,0,1,.88,2.11,7.16,7.16,0,0,1-3.07,2.92,6.32,6.32,0,0,1-2.13.61,6.2,6.2,0,0,1-2.51.4l-.16,0a.19.19,0,0,1-.25-.13l-.14-.05C243.65,144.29,248.22,141,249,140.54Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,140.54c1.07-.6,2.82-1.46,4.08-1.22a1.46,1.46,0,0,1,.88,2.11,7.16,7.16,0,0,1-3.07,2.92,6.32,6.32,0,0,1-2.13.61,6.2,6.2,0,0,1-2.51.4l-.16,0a.19.19,0,0,1-.25-.13l-.14-.05C243.65,144.29,248.22,141,249,140.54Z",
    style: {
      fill: "#222221",
      opacity: 0.30000000000000004,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.09,144.7c-.5,1.34-1.31,3.65-.34,5a.51.51,0,0,0,.52.22,2.54,2.54,0,0,0,1.4-1.07,12.08,12.08,0,0,0,2.77-4.4c.42-1.15-.19-2.87-1.66-2.86S227.5,143.57,227.09,144.7Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.09,144.7c-.5,1.34-1.31,3.65-.34,5a.51.51,0,0,0,.52.22,2.54,2.54,0,0,0,1.4-1.07,12.08,12.08,0,0,0,2.77-4.4c.42-1.15-.19-2.87-1.66-2.86S227.5,143.57,227.09,144.7Z",
    style: {
      fill: "#222221",
      opacity: 0.30000000000000004,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,155.81c.36,1.12,1.57,2.48,2.32.8a.33.33,0,0,0,0-.29c1-2,2-4.15,1-6.39-.63-1.46-2.17-1.52-3.2-.37C214.65,151.19,215.41,154,216,155.81Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,155.81c.36,1.12,1.57,2.48,2.32.8a.33.33,0,0,0,0-.29c1-2,2-4.15,1-6.39-.63-1.46-2.17-1.52-3.2-.37C214.65,151.19,215.41,154,216,155.81Z",
    style: {
      fill: "#222221",
      opacity: 0.30000000000000004,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.81,145.37c-1.73,1.23-5.19,2-6.32,2.16-.43.29-7.48,3.78-10.06,5.93a36.68,36.68,0,0,0-4.73,4.76,49.69,49.69,0,0,1,9.4-4.69c3-1.12,6.5-1.58,9.54-.26,0,.1-3.94,1.84-5.63,2.72s-3,1.87-4.61,2.55a18,18,0,0,1-9.51.89.28.28,0,0,1-.11-.05,32,32,0,0,0-4.85,8.62c-2.86,8-2.7,16.13-1.57,23.71-.09-.14-.2-.26-.31-.4a12.91,12.91,0,0,0-1-1.18,56.75,56.75,0,0,1-.56-7.11.45.45,0,0,0,0-.11,14.06,14.06,0,0,1-6.17-6.38,65.9,65.9,0,0,1-3-10.28,16.61,16.61,0,0,1,7.3,8.09,36.44,36.44,0,0,1,2,6c.05-1.13.12-2.25.25-3.37a74.72,74.72,0,0,1-.18-12,45.68,45.68,0,0,1,.66-5.22,16,16,0,0,1-.92-3.35,2.34,2.34,0,0,1,.22-1.16,1.68,1.68,0,0,1,2.07-1,.35.35,0,0,1,.26.33c0,.21,0,.43,0,.65a29,29,0,0,1-1,4.47,47.16,47.16,0,0,0-.79,6.91c-.1,2.45,0,4.88.12,7.32a36.46,36.46,0,0,1,1.53-5.44A36.5,36.5,0,0,1,222,158.35a55.64,55.64,0,0,1,3.31-5.68,20.2,20.2,0,0,1,1-4.06c.36-.88.87-1.53,1.56-1.49,1.09,0,1.12.8.75,1.71h0A17.25,17.25,0,0,1,226.6,152a50.58,50.58,0,0,0-5.4,9.8,29.91,29.91,0,0,0-1,3.18,35.28,35.28,0,0,1,10.68-12.73,64.32,64.32,0,0,1,9.62-5.39c1.49-1.1,2.88-2.27,4.35-3.47a3.43,3.43,0,0,1,1.66-1,1,1,0,0,1,.88.42C248.19,143.87,247.76,144.69,246.81,145.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194,186.94a23.7,23.7,0,0,1,8.33-2,22.05,22.05,0,0,1,4.37.12,20.68,20.68,0,0,1,4.29,1.05,17.46,17.46,0,0,1,3.9,2.17,18.7,18.7,0,0,1,3.16,3.06,20.76,20.76,0,0,1,4,7.6,33.68,33.68,0,0,0-5.05-6.65,19.2,19.2,0,0,0-6.65-4.48,24.68,24.68,0,0,0-8-1.46A43.84,43.84,0,0,0,194,186.94Z",
    style: {
      fill: "#222221"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.26,195.36a24.82,24.82,0,0,0-4.74-2.11,19.71,19.71,0,0,0-4.9-.92,10.38,10.38,0,0,0-1.25,0,8.57,8.57,0,0,0-1.24,0l-1.26.09c-.41.08-.83.15-1.25.21l-.63.09-.62.16-1.26.29c-.85.21-1.66.51-2.56.71a20.38,20.38,0,0,1,2.22-1.54,15.89,15.89,0,0,1,2.5-1.09c.44-.14.88-.28,1.32-.4l1.36-.23a7.18,7.18,0,0,1,1.39-.12,10.75,10.75,0,0,1,1.39,0,13.46,13.46,0,0,1,5.33,1.43A11.37,11.37,0,0,1,239.26,195.36Z",
    style: {
      fill: "#222221"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M278.42,191.39a75.05,75.05,0,0,1-9,4.39,30.34,30.34,0,0,1-4.56,1.77,4.35,4.35,0,0,1-2.61-.1,2,2,0,0,1-1.2-.73.51.51,0,0,1-.13-.29c-1.31-1.18-1.7-3.08-2.1-4.84a51.3,51.3,0,0,1-1.35-10.7c0-1.31-.27-3,.33-4.26.37-.75.83-.82,1.41-1.24,1.38-1,1.42-2.29,2.42-3.53a2.33,2.33,0,0,1,2.15-1.06c2.1.42,1.88,4.5,2,6a55.3,55.3,0,0,1,0,9.28,46.38,46.38,0,0,1-1.27,8.27A53.23,53.23,0,0,1,274.63,183c1.4-1.19,3.64-3.14,5.66-2.43.82.29.73.91,1.26,1.35,1.12.93,2.34,0,3.51.56C289.44,184.68,279.93,190.53,278.42,191.39Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.42,191.39a75.05,75.05,0,0,1-9,4.39,30.34,30.34,0,0,1-4.56,1.77,4.35,4.35,0,0,1-2.61-.1,2,2,0,0,1-1.2-.73.51.51,0,0,1-.13-.29c-1.31-1.18-1.7-3.08-2.1-4.84a51.3,51.3,0,0,1-1.35-10.7c0-1.31-.27-3,.33-4.26.37-.75.83-.82,1.41-1.24,1.38-1,1.42-2.29,2.42-3.53a2.33,2.33,0,0,1,2.15-1.06c2.1.42,1.88,4.5,2,6a55.3,55.3,0,0,1,0,9.28,46.38,46.38,0,0,1-1.27,8.27A53.23,53.23,0,0,1,274.63,183c1.4-1.19,3.64-3.14,5.66-2.43.82.29.73.91,1.26,1.35,1.12.93,2.34,0,3.51.56C289.44,184.68,279.93,190.53,278.42,191.39Z",
    style: {
      fill: "#222221",
      opacity: 0.30000000000000004,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.32,175.7c-3.14,6.34-6.66,12.47-9.69,18.86-.08.16-.35,0-.28-.12,2.36-5.85,5.54-11.31,8.42-16.91a37.33,37.33,0,0,0,3.46-8.71c.48-2.07.6-4,2-5.59a.52.52,0,0,1,.89.13c.84,2-1.55,4.91-2.81,6.82A28.93,28.93,0,0,1,275.32,175.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.89,174.83c-2.27,5.83-2.78,12.16-3.52,18.3a.11.11,0,1,1-.22,0c.06-8.18,2-17.26,6.32-24.29.38-.63,2.9-4.49,3.92-3.2.54.69-.66,1.8-1.05,2.19-1.25,1.32-2.8,2.23-3.94,3.68,0,0,0,0,0,0C263.79,172.65,263.3,173.79,262.89,174.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.81,176.85a22,22,0,0,1-3.26,7.79c-3.2,5.1-7.78,9.17-12.63,12.66-.11.09-.25-.11-.15-.19,4.63-3.72,9.2-7.62,12.39-12.7a28.17,28.17,0,0,0,2.16-4.15l.14-.34a.08.08,0,0,1,0-.08,22.66,22.66,0,0,0,.08-5.14,3.06,3.06,0,0,1,.33-2.13.15.15,0,0,1,.16-.07C286.45,172.87,286,175.83,285.81,176.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.92,196.32c-6.16,3.42-13.53,4.55-20,7.2-1.48.6-2.94,1.27-4.39,2a13.62,13.62,0,0,1-1.37.65,1.72,1.72,0,0,1-.92.09,1,1,0,0,1-.37-.13,1.47,1.47,0,0,1-.74-1.16,9.45,9.45,0,0,1,.13-3c-.09-1.06-.27-2.12-.38-3.06-.14-1.38-.32-2.74-.53-4.11-.47-2.9-1.2-5.74-1.92-8.59a24.65,24.65,0,0,1-1-7.38c0-1.33.23-3.81,1.41-4.68s1.82-.07,2.24.92.39,2,.7,2.92c.48,1.43,1.33,1.57,2.27,2.46a5.94,5.94,0,0,1,1.45,4.68c-.08,1.35-.23,2.71-.41,4.05.4-1.21.85-2.41,1.31-3.58.83-2.11,1.65-4.74,3.23-6.43a4.84,4.84,0,0,1,1.83-1.29,8.9,8.9,0,0,0,4-2.35c1.08-1.2,2.48-3.37,4.39-3.08s1.71,2.21,1.83,3.64c.23,2.66,2.4,4.1,1.91,7-.4,2.36-2.05,4.39-3.51,6.2a41.05,41.05,0,0,1-3.68,4,22.86,22.86,0,0,1,5.65-2.45,5.16,5.16,0,0,1,2.67-.25c1.29.34,1.36,1.16,3,1,1.22-.14,3.89-1,4.55.69S284.13,195.64,282.92,196.32Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.92,196.32c-6.16,3.42-13.53,4.55-20,7.2-1.48.6-2.94,1.27-4.39,2a13.62,13.62,0,0,1-1.37.65,1.72,1.72,0,0,1-.92.09,1,1,0,0,1-.37-.13,1.47,1.47,0,0,1-.74-1.16,9.45,9.45,0,0,1,.13-3c-.09-1.06-.27-2.12-.38-3.06-.14-1.38-.32-2.74-.53-4.11-.47-2.9-1.2-5.74-1.92-8.59a24.65,24.65,0,0,1-1-7.38c0-1.33.23-3.81,1.41-4.68s1.82-.07,2.24.92.39,2,.7,2.92c.48,1.43,1.33,1.57,2.27,2.46a5.94,5.94,0,0,1,1.45,4.68c-.08,1.35-.23,2.71-.41,4.05.4-1.21.85-2.41,1.31-3.58.83-2.11,1.65-4.74,3.23-6.43a4.84,4.84,0,0,1,1.83-1.29,8.9,8.9,0,0,0,4-2.35c1.08-1.2,2.48-3.37,4.39-3.08s1.71,2.21,1.83,3.64c.23,2.66,2.4,4.1,1.91,7-.4,2.36-2.05,4.39-3.51,6.2a41.05,41.05,0,0,1-3.68,4,22.86,22.86,0,0,1,5.65-2.45,5.16,5.16,0,0,1,2.67-.25c1.29.34,1.36,1.16,3,1,1.22-.14,3.89-1,4.55.69S284.13,195.64,282.92,196.32Z",
    style: {
      fill: "#222221",
      opacity: 0.1,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.56,186.09a0,0,0,1,0,0,.07C254.62,186.15,254.6,186.08,254.56,186.09Z",
    style: {
      fill: "#f1d1c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.86,196.09c-6.08,3.88-16.64,3.13-20.72,9.73l0,.32a1.72,1.72,0,0,1-.92.09c-.92-2.3-.48-4.87-.39-7.33a44,44,0,0,0-.77-11.1c0-.1.12-.13.16,0a31.43,31.43,0,0,1,1.29,8.67c.07,3-.74,6.59.13,9.51l.06-.3c0-3.37,1.36-6.76,2.74-9.76,1.78-3.87,4-7.48,6.15-11.17.08-.15.29,0,.21.15-1.84,3.63-3.75,7.25-5.47,10.94a39.92,39.92,0,0,0-2.69,7C261,195,270.15,190.51,273,182.37a.15.15,0,0,1,.29.1c-2.88,8.65-12.14,13.45-15.61,21.7a9.48,9.48,0,0,1,1.92-1.76,21.2,21.2,0,0,1,5-3.67c3-1.57,6.28-2.34,9.18-4.13.11-.06.22.11.13.19-2.23,1.91-5.15,2.63-7.78,3.82a23.79,23.79,0,0,0-4.47,2.62,26,26,0,0,1,2.61-1.06c4.49-1.59,9.14-2.33,13.48-4.36A.15.15,0,0,1,277.86,196.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.14,181.39a5.62,5.62,0,0,0,.17,2.76.07.07,0,0,0,.13,0,12.09,12.09,0,0,1,0-2.69C254.4,181.3,254.18,181.24,254.14,181.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.51,179.5c-.11.5-.1,1-.19,1.54,0,.17.21.19.27.06a2.61,2.61,0,0,0,.22-1.58C273.77,179.39,273.54,179.34,273.51,179.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.23,194.2a5.15,5.15,0,0,0-.74.47.12.12,0,0,0,.07.2,1.33,1.33,0,0,0,.86-.4C280.55,194.35,280.4,194.1,280.23,194.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.09,202.19c.21,2.34.75,4.85-.41,7.16-.1.2.09.38.24.23,1.15-1.24,8.73-4.21,8.39-5.49-.21-.78-2.31.19-2.6-.89a5,5,0,0,1,.39-1.86c.16-.62.3-1.26.4-1.89s.08-1.33-.43-1.55-1.25.5-1.65,1-.64.87-.95,1.31-.82,1.39-1.26.6-.51-1.53-1.1-2.05C253.77,197.58,254,201.49,254.09,202.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.32,233.11c-.29-.67-.62-1.34-1-2a13.89,13.89,0,0,0-1-1.56c0-.43.07-.87.11-1.3.22-2.42.53-4.83.95-7.22.11-.67.24-1.34.37-2,.3-1.55.64-3.09,1-4.63a27,27,0,0,1,2.38-6.51,16.8,16.8,0,0,1,1.28-2l.41-.52.45-.54.38-.42.06-.06a.17.17,0,0,1,.26.23l-.36.46a4,4,0,0,0-.23.34c-.13.18-.26.38-.39.57s-.1.17-.14.26a16.52,16.52,0,0,0-1.4,2.94c-1.37,3.68-1.72,7.84-2.2,11.62q-.36,2.81-.58,5.61a2.42,2.42,0,0,0,0,.47C251.52,228.9,251.39,231,251.32,233.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.8,221.35s.28-8.11-1.26-12.22-6.44-9.41-6.44-9.41A21.74,21.74,0,0,0,250.8,221.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.52,226.86s2.95-7.57,6-10.73,9.62-6.12,9.62-6.12A21.74,21.74,0,0,1,251.52,226.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.28,220.59a26.68,26.68,0,0,1,10.16-.42,25.85,25.85,0,0,1,9.72,3.47,22.16,22.16,0,0,1,4.09,3.27,20.72,20.72,0,0,1,3.1,4.2,21.18,21.18,0,0,1,2.71,9.81,29.19,29.19,0,0,0-3.92-9.07,22,22,0,0,0-6.93-6.66c-.69-.43-1.4-.81-2.12-1.2s-1.46-.7-2.23-1a32.18,32.18,0,0,0-4.68-1.46A40.78,40.78,0,0,0,223.28,220.59Z",
    style: {
      fill: "#222221"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,230.42a37.72,37.72,0,0,0-5.43-.9,22.36,22.36,0,0,0-5.31.2,19,19,0,0,0-2.57.57,19.94,19.94,0,0,0-2.46,1,30.53,30.53,0,0,0-4.7,2.85,13.19,13.19,0,0,1,4-4.08,13.71,13.71,0,0,1,2.6-1.37,15.62,15.62,0,0,1,2.84-.74,15.33,15.33,0,0,1,5.81.21A14,14,0,0,1,272,230.42Z",
    style: {
      fill: "#222221"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107,176.27c3.82,3.12,8.69,4.37,13.31,5.76,1.3.39,2.57.8,3.84,1.25a5.31,5.31,0,0,0,2.8.44c1.66-.34,1.82-1.83,1.84-3.27a9.06,9.06,0,0,0,0-1.38l0-.31a.19.19,0,0,0-.05-.17c0-.56-.09-1.11-.13-1.63-.24-3-.51-6-.77-8.94a41.59,41.59,0,0,0-.91-7.2c-.22-.83-.46-1.94-1.3-2.37a14.42,14.42,0,0,0-1.5-.43,3.16,3.16,0,0,1-1.13-.82c-.82-.86-2.28-3.46-3.81-2.63-.78.43-1,1.43-1.17,2.21a7.93,7.93,0,0,1-1.81,2.64c-1.15,1.5-.86,3.43-.23,5.08a27.32,27.32,0,0,0,3.48,6c1.39,1.94,2.91,3.78,4.32,5.71a37.62,37.62,0,0,1,2.18,3.3c.33.56.63,1.12.91,1.7a5.47,5.47,0,0,1,.51,1.25,62,62,0,0,0-5.5-6c-2-2-3.78-4.37-6.06-6.11a10,10,0,0,0-5.93-2.22,10.63,10.63,0,0,1-3.59-.43,18.15,18.15,0,0,0-3.18-1c-2.41-.34-1.21,2.5-.69,3.65A16,16,0,0,0,107,176.27Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,176.27c3.82,3.12,8.69,4.37,13.31,5.76,1.3.39,2.57.8,3.84,1.25a5.31,5.31,0,0,0,2.8.44c1.66-.34,1.82-1.83,1.84-3.27a9.06,9.06,0,0,0,0-1.38l0-.31a.19.19,0,0,0-.05-.17c0-.56-.09-1.11-.13-1.63-.24-3-.51-6-.77-8.94a41.59,41.59,0,0,0-.91-7.2c-.22-.83-.46-1.94-1.3-2.37a14.42,14.42,0,0,0-1.5-.43,3.16,3.16,0,0,1-1.13-.82c-.82-.86-2.28-3.46-3.81-2.63-.78.43-1,1.43-1.17,2.21a7.93,7.93,0,0,1-1.81,2.64c-1.15,1.5-.86,3.43-.23,5.08a27.32,27.32,0,0,0,3.48,6c1.39,1.94,2.91,3.78,4.32,5.71a37.62,37.62,0,0,1,2.18,3.3c.33.56.63,1.12.91,1.7a5.47,5.47,0,0,1,.51,1.25,62,62,0,0,0-5.5-6c-2-2-3.78-4.37-6.06-6.11a10,10,0,0,0-5.93-2.22,10.63,10.63,0,0,1-3.59-.43,18.15,18.15,0,0,0-3.18-1c-2.41-.34-1.21,2.5-.69,3.65A16,16,0,0,0,107,176.27Z",
    style: {
      fill: "#222221",
      opacity: 0.30000000000000004,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.11,180.08a33.73,33.73,0,0,0,0-9.88,53.43,53.43,0,0,0-6.55-17.88,14.48,14.48,0,0,0-2.36-3.37c-.42-.4-1.36-.84-1.33.14a3.67,3.67,0,0,0,1.52,2.3,18.49,18.49,0,0,1,2.43,2.15c.53,1,1,2,1.52,3a58.26,58.26,0,0,1,3.11,7.81,36.18,36.18,0,0,1,1.6,15.74A0,0,0,1,0,126.11,180.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.41,181.54a33.59,33.59,0,0,1-9.46-2.87,53.2,53.2,0,0,1-15.22-11.44A13.67,13.67,0,0,1,98.19,164c-.27-.51-.42-1.54.51-1.23s1.43,1.35,1.77,2.12a17.92,17.92,0,0,0,1.35,3c.79.79,1.59,1.56,2.42,2.32a58.07,58.07,0,0,0,6.58,5.23,36.14,36.14,0,0,0,14.6,6.08S125.46,181.55,125.41,181.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,159.62q2.58,3.44,5.34,6.73a163.49,163.49,0,0,0,11.67,12.45s.08,0,0-.06c-4-4-7.79-8.27-11.41-12.61q-2.72-3.25-5.26-6.62c-.34-.47-.69-.93-1-1.41-.57-1.49-1-2.87-1.68-4.32-.34-.68-1.15-2.26-1.92-1.7C103.77,152.82,107.32,157.35,109,159.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.32,176.06a17,17,0,0,0,4.05,4.33,31.72,31.72,0,0,0,11.46,5.45,28.28,28.28,0,0,0,12.18.89l.15,0a.08.08,0,0,0,.1,0,1.14,1.14,0,0,0,.31-.09s.39-.07.3-.11a7.26,7.26,0,0,1,.55-.67,18,18,0,0,0,1.94-2.61,12.12,12.12,0,0,0,1.17-3.88c.45-3.09,0-6.24.38-9.34.29-2.7,1.31-5.28,1.22-8,0-.6-.1-1.57-.94-1.41-1.07.21-1.22,1.69-1.92,2.31-.05.16-.18.21-.37.15-.24.12-.39.05-.46-.22a2.55,2.55,0,0,1-.24-.5,11.39,11.39,0,0,1-.41-1.11c-.22-.66-.39-1.34-.57-2a8.2,8.2,0,0,0-1.34-3.4,1,1,0,0,0-1.74.22,8,8,0,0,0-.41,3.45c0,.81-.17,2-1.27,1.75-.45-.09-.86-.36-1.31-.45a1.74,1.74,0,0,0-1.93,1.13c-.47,1.14-.07,2.59.17,3.75a37.46,37.46,0,0,0,1.27,4.4c1,2.74,3.2,7.92,4.34,10.59.62,1.47-6.34-13.7-9-16.76a3.63,3.63,0,0,0-2.41-1c-.58,0-1.12.23-1.7.22a4.5,4.5,0,0,1-1.7-.5c-1.44-.64-3.9-1.4-4.3.83-.19,1,.28,2,.3,3a7.31,7.31,0,0,1-.94,2.7c-.83,2.13,1.16,4,2.55,5.42a41.9,41.9,0,0,0,5.62,4.78c1.24.9,6,4,7.29,4.8-1.65-.84-6.76-4-8.37-4.94-1.06-.61-2.1-1.25-3.12-1.91s-1.83-1.32-2.8-1.85a4.66,4.66,0,0,0-2.54-.46,19.51,19.51,0,0,1-3.51-.65c-.62-.1-1.77-.49-2.22.14C100.77,174.91,101,175.61,101.32,176.06Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.32,176.06a17,17,0,0,0,4.05,4.33,31.72,31.72,0,0,0,11.46,5.45,28.28,28.28,0,0,0,12.18.89l.15,0a.08.08,0,0,0,.1,0,1.14,1.14,0,0,0,.31-.09s.39-.07.3-.11a7.26,7.26,0,0,1,.55-.67,18,18,0,0,0,1.94-2.61,12.12,12.12,0,0,0,1.17-3.88c.45-3.09,0-6.24.38-9.34.29-2.7,1.31-5.28,1.22-8,0-.6-.1-1.57-.94-1.41-1.07.21-1.22,1.69-1.92,2.31-.05.16-.18.21-.37.15-.24.12-.39.05-.46-.22a2.55,2.55,0,0,1-.24-.5,11.39,11.39,0,0,1-.41-1.11c-.22-.66-.39-1.34-.57-2a8.2,8.2,0,0,0-1.34-3.4,1,1,0,0,0-1.74.22,8,8,0,0,0-.41,3.45c0,.81-.17,2-1.27,1.75-.45-.09-.86-.36-1.31-.45a1.74,1.74,0,0,0-1.93,1.13c-.47,1.14-.07,2.59.17,3.75a37.46,37.46,0,0,0,1.27,4.4c1,2.74,3.2,7.92,4.34,10.59.62,1.47-6.34-13.7-9-16.76a3.63,3.63,0,0,0-2.41-1c-.58,0-1.12.23-1.7.22a4.5,4.5,0,0,1-1.7-.5c-1.44-.64-3.9-1.4-4.3.83-.19,1,.28,2,.3,3a7.31,7.31,0,0,1-.94,2.7c-.83,2.13,1.16,4,2.55,5.42a41.9,41.9,0,0,0,5.62,4.78c1.24.9,6,4,7.29,4.8-1.65-.84-6.76-4-8.37-4.94-1.06-.61-2.1-1.25-3.12-1.91s-1.83-1.32-2.8-1.85a4.66,4.66,0,0,0-2.54-.46,19.51,19.51,0,0,1-3.51-.65c-.62-.1-1.77-.49-2.22.14C100.77,174.91,101,175.61,101.32,176.06Z",
    style: {
      fill: "#222221",
      opacity: 0.09,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.13,180.93a39.85,39.85,0,0,0,19.55,5.83.08.08,0,0,0,.08,0l.25,0,.15,0a.08.08,0,0,0,.1,0,1.14,1.14,0,0,0,.31-.09s.39-.07.3-.11a7.26,7.26,0,0,1,.55-.67,16,16,0,0,0,1.94-7.73c-.09-1.73-.47-3.45-.63-5.19a35,35,0,0,1-.1-5.32,0,0,0,0,0,0,0,44.57,44.57,0,0,0-.12,5.17c.07,1.65.35,3.28.47,4.92.23,3.07-.93,5.63-2,8.34a23.72,23.72,0,0,0,.5-7.38,59.26,59.26,0,0,0-1.82-8.82c0-.08-.13-.06-.11,0,.55,2.92,1.32,5.84,1.63,8.79a24.47,24.47,0,0,1-.42,7.59c-2.4-2.91-4.32-6.16-6.41-9.28a74.62,74.62,0,0,0-6.7-8.61s-.11,0-.07.07a79.4,79.4,0,0,1,6.81,9.19,68.78,68.78,0,0,0,6,8.57,42.09,42.09,0,0,1-6.87-5.71c-2.14-2.35-4.2-4.78-6.24-7.22,0,0,0,0,0,0,2,2.58,4,5.21,6.23,7.64a33.62,33.62,0,0,0,7.1,5.65c-6.61-.24-12.7-3.84-18.26-7.33a0,0,0,1,0,0,0c4.34,2.77,8.79,5.63,13.7,6.87a41.86,41.86,0,0,1-6.66-1.29,40.3,40.3,0,0,1-9.11-4A0,0,0,1,0,109.13,180.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.42,162.52c0-.09.15-.09.14,0a51.27,51.27,0,0,0,0,5.26.1.1,0,0,1-.19,0A15.4,15.4,0,0,1,128.42,162.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.1,169.61a9.61,9.61,0,0,1,1.29,1.18c0,.06,0,.17-.1.12a9.83,9.83,0,0,1-1.27-1.23C113,169.63,113,169.56,113.1,169.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.24,178l.7.48c.1.06,0,.21-.08.14l-.67-.52C109.13,178.08,109.18,178,109.24,178Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.45,188c2.09.77,4.53,1.28,5.77,3.33a.18.18,0,0,0,.33-.13c-.34-1.6,1.72-10,.43-10.18-.78-.12-1.22,2.26-2.31,2.09-.46-.07-1-.82-1.33-1.13A14.53,14.53,0,0,0,128,180.8c-.44-.33-1.08-.63-1.57-.23s-.33,1.38-.15,2,.35,1,.53,1.43.68,1.35-.25,1.44a7.13,7.13,0,0,0-2.39.2C122.38,186.39,125.82,187.74,126.45,188Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.53,215.6l-.08,0-1.43-.21c-.26,0-.53,0-.79,0-.37-1-.78-1.88-1.22-2.79-.23-.5-.48-1-.73-1.5q-1.26-2.46-2.72-4.76c-3.14-5-6.46-9.78-9.22-14.91q-1.31-2.43-2.42-5c-.06-.12-.1-.24-.15-.35-.2-.49-.41-1-.6-1.5,0-.12.14-.2.2-.08.15.37.31.73.49,1.1,0,.1.09.2.13.29s0,0,0,0,.08.18.13.27a42.13,42.13,0,0,0,2.39,4.31c2.38,3.84,5.23,7.43,7.93,11.1.2.27.4.54.59.82a67.16,67.16,0,0,1,4.79,7.36A45.06,45.06,0,0,1,148.53,215.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.85,212.42s-6-5.5-10.1-7-11.33-1.25-11.33-1.25A21.75,21.75,0,0,0,145.85,212.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.65,202.82s-1.4-8-.44-12.27,5.06-10.22,5.06-10.22A21.72,21.72,0,0,1,140.65,202.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.09,152.26c1.28-.31,2.13,2.38,2.36,3.21a9.67,9.67,0,0,1-.76,6.56,1.37,1.37,0,0,1-.2.44s0,0,0,.06,0,0,0,0l-.13.13a.44.44,0,0,1-.44.09c-1.65-.72-1.57-3.08-1.55-4.54C145.33,157.31,144.58,152.63,146.09,152.26Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.09,152.26c1.28-.31,2.13,2.38,2.36,3.21a9.67,9.67,0,0,1-.76,6.56,1.37,1.37,0,0,1-.2.44s0,0,0,.06,0,0,0,0l-.13.13a.44.44,0,0,1-.44.09c-1.65-.72-1.57-3.08-1.55-4.54C145.33,157.31,144.58,152.63,146.09,152.26Z",
    style: {
      fill: "#222221",
      opacity: 0.2,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.55,166.54c-.78,2.19.68,4.31,2,5.87.51.6,2.06,2.3,2.72,1.43a.21.21,0,0,0,.24-.15,4,4,0,0,0-.29-2.61c-.51-1.38-1-2.81-1.65-4.15S138.25,164.62,137.55,166.54Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.55,166.54c-.78,2.19.68,4.31,2,5.87.51.6,2.06,2.3,2.72,1.43a.21.21,0,0,0,.24-.15,4,4,0,0,0-.29-2.61c-.51-1.38-1-2.81-1.65-4.15S138.25,164.62,137.55,166.54Z",
    style: {
      fill: "#222221",
      opacity: 0.2,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.71,189.66a14.88,14.88,0,0,1-5.31,8.17,42.4,42.4,0,0,1-.82,10.06c-.4.29-.77.61-1.13.93.18-.86.33-1.71.46-2.58a.31.31,0,0,0,0-.08c-5.41-2.85-7.83-8.36-9.86-13.93l0,0c.16,0,8.56,3.52,10.11,12.52a46.94,46.94,0,0,0-.33-12.8c-2.28-6.66-8-11.41-13.54-15.79a8.36,8.36,0,0,1-2.49-2.57h0a1.07,1.07,0,0,1-.1-.22c-.22-.53-.49-1.68.22-2s1.28.57,1.63,1.06a1.82,1.82,0,0,1,.15.23c1,1.38,1.89,2.83,2.77,4.27a53.39,53.39,0,0,1,5.91,5.13,26.91,26.91,0,0,1,4.77,6.53c-.09-.36-.16-.72-.25-1.09a65.06,65.06,0,0,0-6-14.69,45,45,0,0,1-3-6.2,13.78,13.78,0,0,1-.95-4.73,4.19,4.19,0,0,1,.2-1.15c.27-.83,1-1.21,1.57-.38a2.51,2.51,0,0,1,.35,1.12h0c.08.77,0,1.63,0,2.2.09,1.47.16,2.95.21,4.43.48,1,1,1.91,1.54,2.85a67.18,67.18,0,0,1,7,15.75,48.75,48.75,0,0,1,1.41,7.28,36,36,0,0,1,1.11-5.73c.77-2.79,4.05-7.65,4.08-7.67A17.67,17.67,0,0,1,163.71,189.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.3,231.1a17.87,17.87,0,0,1,5.28-9.64,21.91,21.91,0,0,1,7-4.62l1.3-.54,1.38-.41a15.93,15.93,0,0,1,5.71-.51l1.43.2c.47.07.93.23,1.39.34l.69.19.67.25c.43.18.89.33,1.31.55a21.05,21.05,0,0,1,8.34,7.2,27.39,27.39,0,0,0-8.9-5.9,16,16,0,0,0-10.16-.57,24.84,24.84,0,0,0-9.26,4.86A21.73,21.73,0,0,0,126.3,231.1Z",
    style: {
      fill: "#222221"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.64,205.89a37,37,0,0,0-7.77-.31,24.77,24.77,0,0,0-7.38,1.6,21,21,0,0,0-6.36,4,32.7,32.7,0,0,0-4.94,6,18.93,18.93,0,0,1,3.93-7,18.51,18.51,0,0,1,3.07-2.72,20.74,20.74,0,0,1,3.63-1.94,21.32,21.32,0,0,1,15.82.4Z",
    style: {
      fill: "#222221"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,218.07a8.86,8.86,0,0,1,3.94-1.62,10,10,0,0,1,4.37.21,9.23,9.23,0,0,1,3.85,2.09,8.84,8.84,0,0,1,1.45,1.61,11.31,11.31,0,0,1,1,1.87c-.61-.4-1.1-.87-1.66-1.25a18.79,18.79,0,0,0-1.65-1.09,13.52,13.52,0,0,0-3.49-1.48,15.76,15.76,0,0,0-3.79-.55A29.58,29.58,0,0,0,117,218.07Z",
    style: {
      fill: "#222221"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.59,251.08a20,20,0,0,1,6.79-2.62,23.12,23.12,0,0,1,7.38-.26,26.64,26.64,0,0,1,3.63.77,22.94,22.94,0,0,1,3.42,1.45,19.54,19.54,0,0,1,5.72,4.51,41.26,41.26,0,0,0-6.31-3.22,29.58,29.58,0,0,0-3.3-1.08,28.07,28.07,0,0,0-3.39-.63,32.18,32.18,0,0,0-6.94-.14A43,43,0,0,0,178.59,251.08Z",
    style: {
      fill: "#222221"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.06,265a21.58,21.58,0,0,1,7.09-9.86,23.87,23.87,0,0,1,11.35-4.87,22.13,22.13,0,0,1,12.27,1.47,19.3,19.3,0,0,1,5.21,3.36,17.46,17.46,0,0,1,3.81,4.76,21.59,21.59,0,0,0-4.37-4.07,21.27,21.27,0,0,0-5.18-2.74,21.56,21.56,0,0,0-5.67-1.2,10,10,0,0,0-1.45-.07l-1.45,0c-1,.11-1.94.15-2.9.31l-1.44.25c-.24,0-.48.08-.72.14l-.7.19-1.4.39c-.46.16-.91.35-1.37.51a24.27,24.27,0,0,0-2.66,1.19c-.83.51-1.71.95-2.49,1.53A26.41,26.41,0,0,0,197.06,265Z",
    style: {
      fill: "#222221"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.79,259.84a21.59,21.59,0,0,0-4.37-4.07,20.9,20.9,0,0,0-5.18-2.73,21.19,21.19,0,0,0-5.66-1.21,10.27,10.27,0,0,0-1.46-.07h-1.45c-1,.11-1.94.13-2.9.3l-1.44.25c-.24,0-.48.08-.72.14l-.7.2-1.41.39c-.45.14-.9.34-1.36.51a17,17,0,0,0-2.28,1l-.38.18-.91.52a18.42,18.42,0,0,0-1.58,1,26.41,26.41,0,0,0-7.93,8.73,21.48,21.48,0,0,1,7.09-9.85,18.12,18.12,0,0,1,1.82-1.34c.4-.25.81-.5,1.22-.73a25.44,25.44,0,0,1,8.31-2.8,22,22,0,0,1,12.27,1.46,19.33,19.33,0,0,1,5.2,3.36A17.35,17.35,0,0,1,236.79,259.84Z",
    style: {
      fill: "#222221"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M182.64,223.73a64.84,64.84,0,0,0,7,5.1,26.93,26.93,0,0,0,3.61,2.19,3.74,3.74,0,0,0,2.25.31,1.68,1.68,0,0,0,1.13-.44.48.48,0,0,0,.15-.22c1.3-.82,1.92-2.37,2.53-3.81a45.4,45.4,0,0,0,2.76-8.92c.22-1.11.68-2.54.36-3.68-.21-.69-.58-.82-1-1.27-1-1.05-.87-2.16-1.53-3.37a2,2,0,0,0-1.67-1.23c-1.85,0-2.28,3.56-2.61,4.81a46.85,46.85,0,0,0-1.4,7.9,40.6,40.6,0,0,0-.16,7.24,45.94,45.94,0,0,0-6.94-11.19c-1-1.22-2.62-3.22-4.45-2.92-.74.12-.76.66-1.28,1-1.1.62-2-.38-3.08-.05C174.26,216.35,181.48,222.77,182.64,223.73Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.64,223.73a64.84,64.84,0,0,0,7,5.1,26.93,26.93,0,0,0,3.61,2.19,3.74,3.74,0,0,0,2.25.31,1.68,1.68,0,0,0,1.13-.44.48.48,0,0,0,.15-.22c1.3-.82,1.92-2.37,2.53-3.81a45.4,45.4,0,0,0,2.76-8.92c.22-1.11.68-2.54.36-3.68-.21-.69-.58-.82-1-1.27-1-1.05-.87-2.16-1.53-3.37a2,2,0,0,0-1.67-1.23c-1.85,0-2.28,3.56-2.61,4.81a46.85,46.85,0,0,0-1.4,7.9,40.6,40.6,0,0,0-.16,7.24,45.94,45.94,0,0,0-6.94-11.19c-1-1.22-2.62-3.22-4.45-2.92-.74.12-.76.66-1.28,1-1.1.62-2-.38-3.08-.05C174.26,216.35,181.48,222.77,182.64,223.73Z",
    style: {
      fill: "#222221",
      opacity: 0.30000000000000004,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.65,210.83c1.72,5.87,3.79,11.63,5.41,17.53.05.14.3.08.26-.06-1.13-5.35-3-10.48-4.63-15.69a32.31,32.31,0,0,1-1.63-7.94c-.09-1.84.09-3.49-.9-5.07a.44.44,0,0,0-.77,0c-1,1.62.57,4.42,1.37,6.23A24.51,24.51,0,0,0,187.65,210.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.37,212c1.06,5.3.54,10.77.24,16.12a.1.1,0,0,0,.2,0c1.18-7,.87-15-1.73-21.66-.23-.59-1.8-4.26-2.86-3.32-.56.51.29,1.64.56,2a44.36,44.36,0,0,1,2.81,3.73s0,0,0,0C197.94,210,198.18,211,198.37,212Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.53,210.22a19.09,19.09,0,0,0,1.61,7.13,40.46,40.46,0,0,0,8.86,12.7c.08.08.23-.06.15-.15-3.38-3.87-6.69-7.87-8.64-12.69a22.73,22.73,0,0,1-1.21-3.86c0-.09-.05-.2-.08-.31s0,0,0-.07a19.73,19.73,0,0,1,.71-4.38c.17-.67.41-1.83-.09-2C178.59,206.73,178.54,209.33,178.53,210.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.06,227.25c4.74,3.84,10.85,5.92,16,9.15,1.17.74,2.31,1.53,3.44,2.34a11,11,0,0,0,1.07.77,1.44,1.44,0,0,0,.77.21.8.8,0,0,0,.34-.05,1.31,1.31,0,0,0,.8-.88,7.88,7.88,0,0,0,.34-2.55c.24-.89.55-1.77.78-2.55q.5-1.73,1.08-3.42c.83-2.41,1.88-4.71,2.93-7a21.64,21.64,0,0,0,2-6.14c.15-1.14.37-3.28-.5-4.2s-1.55-.33-2,.44-.63,1.64-1,2.39c-.62,1.15-1.36,1.14-2.3,1.76a5.15,5.15,0,0,0-1.94,3.77c-.14,1.16-.21,2.34-.26,3.51-.16-1.1-.36-2.18-.58-3.25-.39-1.92-.69-4.29-1.78-6a4.24,4.24,0,0,0-1.36-1.37,7.7,7.7,0,0,1-3-2.6c-.75-1.19-1.61-3.25-3.28-3.29s-1.79,1.63-2.11,2.83c-.6,2.23-2.67,3.13-2.68,5.67,0,2.07,1.08,4.05,2.05,5.81a35.66,35.66,0,0,0,2.54,4,20,20,0,0,0-4.45-2.94,4.42,4.42,0,0,0-2.24-.62c-1.15.1-1.34.79-2.7.38-1-.3-3.16-1.47-4-.1S177.13,226.49,178.06,227.25Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.06,227.25c4.74,3.84,10.85,5.92,16,9.15,1.17.74,2.31,1.53,3.44,2.34a11,11,0,0,0,1.07.77,1.44,1.44,0,0,0,.77.21.8.8,0,0,0,.34-.05,1.31,1.31,0,0,0,.8-.88,7.88,7.88,0,0,0,.34-2.55c.24-.89.55-1.77.78-2.55q.5-1.73,1.08-3.42c.83-2.41,1.88-4.71,2.93-7a21.64,21.64,0,0,0,2-6.14c.15-1.14.37-3.28-.5-4.2s-1.55-.33-2,.44-.63,1.64-1,2.39c-.62,1.15-1.36,1.14-2.3,1.76a5.15,5.15,0,0,0-1.94,3.77c-.14,1.16-.21,2.34-.26,3.51-.16-1.1-.36-2.18-.58-3.25-.39-1.92-.69-4.29-1.78-6a4.24,4.24,0,0,0-1.36-1.37,7.7,7.7,0,0,1-3-2.6c-.75-1.19-1.61-3.25-3.28-3.29s-1.79,1.63-2.11,2.83c-.6,2.23-2.67,3.13-2.68,5.67,0,2.07,1.08,4.05,2.05,5.81a35.66,35.66,0,0,0,2.54,4,20,20,0,0,0-4.45-2.94,4.42,4.42,0,0,0-2.24-.62c-1.15.1-1.34.79-2.7.38-1-.3-3.16-1.47-4-.1S177.13,226.49,178.06,227.25Z",
    style: {
      fill: "#222221",
      opacity: 0.1,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.78,222.81s0,.07,0,.06S203.74,222.79,203.78,222.81Z",
    style: {
      fill: "#f1d1c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.41,227.81C187,232,196.12,233,198.6,239.23l0,.28a1.44,1.44,0,0,0,.77.21c1.13-1.82,1.14-4.07,1.44-6.18a38.13,38.13,0,0,1,2.33-9.35c0-.08-.08-.13-.13-.05a26.9,26.9,0,0,0-2.41,7.2c-.51,2.51-.36,5.72-1.54,8.08a2.35,2.35,0,0,1,0-.26c.52-2.88-.14-6-.86-8.73-.93-3.57-2.32-7-3.56-10.45,0-.14-.25,0-.21.1,1,3.37,2.11,6.74,3,10.14a34.42,34.42,0,0,1,1.24,6.36c-1.74-7.15-8.82-12.36-10-19.72a.14.14,0,0,0-.27,0c1.16,7.81,8.32,13.3,10,20.85a7.82,7.82,0,0,0-1.37-1.79,18.18,18.18,0,0,0-3.71-3.88c-2.32-1.8-5-2.94-7.21-4.9-.08-.08-.2,0-.13.14,1.61,2,4,3,6.05,4.42a20.72,20.72,0,0,1,3.42,2.91,20.79,20.79,0,0,0-2.07-1.29c-3.58-2-7.43-3.36-10.83-5.75A.13.13,0,0,0,182.41,227.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.84,218.87a5,5,0,0,1-.56,2.33c0,.06-.13,0-.11,0a10.22,10.22,0,0,0,.44-2.28C204.63,218.75,204.83,218.73,204.84,218.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.62,214.34c0,.44-.07.89-.07,1.34,0,.14-.21.13-.24,0a2.32,2.32,0,0,1,.05-1.38C188.41,214.2,188.61,214.19,188.62,214.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.67,225.85a5.59,5.59,0,0,1,.57.51.1.1,0,0,1-.09.16,1.11,1.11,0,0,1-.67-.47C180.38,225.93,180.55,225.74,180.67,225.85Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.76,236.47c-.53,2-1.37,4-.73,6.16.06.18-.13.31-.23.15-.8-1.23-6.82-4.9-6.33-5.94.29-.63,1.94.52,2.35-.37a4.35,4.35,0,0,0,0-1.64c0-.55-.07-1.11-.06-1.66s.13-1.15.6-1.26,1,.61,1.26,1.1.41.83.61,1.25.49,1.32,1,.71.67-1.23,1.25-1.58C202.73,232.59,201.92,235.87,201.76,236.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.19,253.06c-.41.23-.82.48-1.22.73l-.06-.15c-1.33-3-2.93-5.94-4.28-9A36.74,36.74,0,0,1,199,235.5s0-.05,0,0c1,5.59,4.65,10.72,7.22,15.68C206.58,251.78,206.9,252.42,207.19,253.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.27,251.78s-.8-8.58.59-13,6.24-10.37,6.24-10.37A23.08,23.08,0,0,1,205.27,251.78Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.78,387.07c1.84.61,54.19.46,56.18-.81.75-.47,1.18-8.1,1.43-17.33q.08-3,.13-6.14c0-2.48.07-5,.08-7.42.07-10.93-.08-20.56-.08-20.56H352.43l0,20.56v7.42l.18,6.14s-20,9-22.06,10.65S327,386.47,328.78,387.07Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.44,366.92c0,.68,0,1.35-.05,2-.25,9.23-.68,16.86-1.43,17.33-2,1.27-54.34,1.42-56.18.81s-.22-5.87,1.8-7.49c1.09-.87,7.33-3.86,12.89-6.45-1.69,1.52-4,3.83-3.36,4.65,1.68,2.22,35.58-2.43,44.77-9.82A8.56,8.56,0,0,1,386.44,366.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.88,189.58s-9.21,91.1-9.42,92.25c0,.15-.1,1.91-.19,4.76-.5,15.69-1.72,64.59-1.72,64.59H349s2.45-57.92,3.86-71.43c1.79-17.24,13.1-90.17,13.1-90.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,285q1.74-29.61,5.23-59.08c1.32-11.06,2.91-22.09,4.49-33.13,0-.09.16-.09.15,0-2.91,19.64-5,39.43-6.74,59.2s-3,39.54-3.82,59.34c-.46,11.23-.81,22.46-1.17,33.68a.21.21,0,0,1-.42,0C382.22,325,382.8,305,384,285Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.34,345.12c1-.13,12.42-.3,16.81-.3,3.75,0,15.52.3,16.81.29.1,0,.09.1,0,.12-1.54.24-8.24.42-15.43.42-4.38,0-17.62-.31-18.19-.38A.08.08,0,0,1,351.34,345.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.88,189.58s-9.21,91.1-9.42,92.25c0,.15-.1,1.91-.19,4.76l-17.72-97Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.2,387.42c1.93.11,52.45-13.61,54-15.35.61-.66-1-8.13-3.11-17.11-.46-1.94-.87-4-1.47-6-.75-2.51-1.53-5-2.32-7.43-3.37-10.47-6.62-19.14-6.62-19.14l-32,8.59,5.7,19,2.33,7.8,1.76,5.89s-17,13.9-18.54,16S398.28,387.3,400.2,387.42Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.24,372.07c-1.59,1.74-52.11,15.46-54.05,15.35s-1.73-5.62-.2-7.71c.94-1.27,7.55-6.89,12.61-11.1-1.46,1.72-3.74,4.65-3,5.42,1.94,1.91,33.41-7,42.34-15.49C453.66,365.85,454.76,371.5,454.24,372.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.93,189.58s2.48,13.15,11.66,19.85c0,0,12.93,71.09,14.56,79.13,3.16,15.63,16.47,60.24,16.47,60.24L447,337.08s-16.56-53.84-18.78-59.49c-1.21-3.08-10.49-62-10.3-63.39,2.26-16.83-5.73-24.71-5.73-24.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.36,192.51a12.51,12.51,0,0,0,4.6,6.6,15.53,15.53,0,0,0,8.35,2.86c.5,0,.54.81,0,.81-6.12,0-12.32-3.88-13.21-10.23C396.09,192.4,396.32,192.37,396.36,192.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.71,205.26a34,34,0,0,1,6.33,3.36c2.1,1.3,4,2.82,6.08,4.23a.08.08,0,0,1-.08.13c-2.12-1.22-4.34-2.29-6.45-3.55a40.12,40.12,0,0,1-6-4C371.55,205.36,371.62,205.23,371.71,205.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.85,192.49c.33,1.4.73,2.78,1.1,4.18s.62,2.64,1,3.93a6.84,6.84,0,0,0,2,3.25c.54.45,1.13.85,1.7,1.27l1,.66c0-.18-.09-.37-.14-.56-.12-.53-.23-1.07-.35-1.6-.25-1.18-.5-2.37-.73-3.56-.47-2.33-.91-4.69-1.5-7a.07.07,0,1,1,.14,0c.69,2.28,1.44,4.53,2.06,6.83.3,1.12,1.45,6.71,1.51,7.11s.11.82.14,1.23a4.87,4.87,0,0,1,.06,1.26c0,.11-.14.1-.19,0h0a5,5,0,0,1-.41-1.2c-.12-.4-.23-.8-.32-1.21l-.09-.44c-.57-.32-1.11-.74-1.64-1.09s-1.16-.75-1.71-1.17a6.38,6.38,0,0,1-2.17-3.06,23.75,23.75,0,0,1-.85-4c-.25-1.59-.45-3.19-.75-4.77C370.69,192.43,370.83,192.39,370.85,192.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.93,340.74c.91-.41,11.8-3.9,16-5.18,3.6-1.09,14.94-4.24,16.17-4.62.09,0,.12.07,0,.11-1.4.68-7.75,2.8-14.63,4.89-4.2,1.28-16.95,4.85-17.52,4.95A.08.08,0,0,1,409.93,340.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.69,301.18c-1.52-4.42-3.06-8.83-4.55-13.26a105,105,0,0,1-3.55-13.29c-1.83-9.18-3.41-18.43-4.9-27.68q-1.12-7-2.13-14.08-.48-3.48-.95-7c-.3-2.26-.67-4.51-.79-6.79-.46-8.42,2.54-17.32-1.12-25.36a14.13,14.13,0,0,0-1.5-2.54c-.05-.07-.17,0-.12.08,4.88,7.63,2.2,16.9,2.06,25.31a88.09,88.09,0,0,0,1.35,13.74q1,6.9,2.07,13.78,2.13,13.81,4.7,27.56A112.85,112.85,0,0,0,424.32,285c1.39,4.42,3,8.78,4.5,13.16,3.08,8.85,11,31,11.39,32.12,0,.09.19.05.15-.05C437.36,321.35,433.75,310.08,430.69,301.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.42,140.72c-8.8,9.29-30.17,19.62-37.22,19.62-8,0-21.54-11.15-31.7-20.55-2.23-2.06,11.51-22.28,14-20.16,6.15,5.31,20.55,19.81,22.78,20.16,3.26.51,16.4-3,26.81-5.94C387.63,130.56,385.89,136,381.42,140.72Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.69,141.8c2.87,0,10.21-17.42,8.76-20a11.36,11.36,0,0,0-2-2.18h0A42.05,42.05,0,0,1,322.81,108c-.61-4.84-.95-12.09-3.57-11.86-3.81.32-4.47,9.55-4.53,14.87-2.5-1.45-4.79-2.46-6.34-2.56-5.15-.33-9.54,22.47-5.66,26S316.82,141.81,319.69,141.8Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.09,138.81s5.69,1,8.49-1.93c8.74-9.14-1.17-37.69-6-36.53s-9.49,19.23-9.49,19.23Zm.22-2.79-5.45-15s3.86-15.73,7.61-16.63,11.25,23,4.44,30.11C301.73,136.81,297.31,136,297.31,136Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "249.52 124.59 251.27 133.46 243.69 137.87 249.52 124.59",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "278.27 159.6 308 146.44 283.67 104.58 264.67 113.19 278.27 159.6",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.67 104.58 285.29 100.02 260.8 110.56 264.67 113.19 283.67 104.58",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.49 136.45 274.68 147.35 249.41 134.52 250.88 131.43 271.49 136.45",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,128.63c-2.79-2.7-8.83-2.93-8.86-.37,0,1.41,2.16,1.81,4.8.81A8.22,8.22,0,0,1,247,128.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.88,137.71c-2.24,1-3.84,4.41-2.37,5,.82.35,1.58-.81,1.64-2.58A5.15,5.15,0,0,1,242.88,137.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.74,133a10.81,10.81,0,0,0-8.47,1.87c-3.15,2.28-5,7-2,8.17,1.16.49,2.8-.5,4.07-2.36C239.27,137.81,240.37,134.12,243.74,133Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.19,110.52c.77,2.57-2.7,2-2.7,2s4.79,2,4.55,5-4.4,2-4.7,2c.26.11,4.61,2.09,4.07,5s-4.61,1.5-4.87,1.4c.21.18,2.89,2.58,2,4.72-1.59,3.68-8.62-2.27-11.84-1.86,0,0,.07,5.53,0,5.69,0,0-6.8-5.52-7.11-9.9a2.81,2.81,0,0,1,2-2.91s-2.39-1.53-2-3.87c.18-1.19,2.26-2,2.26-2a3.51,3.51,0,0,1-1.42-3.36c.35-1.64,2.39-2.16,2.39-2.16s-1.21-2.09-.31-3.65C300.26,103.47,314.56,105,316.19,110.52Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.05,110.14s-.05-.07,0-.07a24.91,24.91,0,0,1,14.63,2.46c.14.08.08.34-.09.29A51,51,0,0,0,299.05,110.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.71,115.75s0-.09,0-.1a23.34,23.34,0,0,1,15.79,3.69c.16.11.2.37,0,.25C310.25,117.65,302.36,115.86,297.71,115.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.79,126.22c-4.58-3-9.65-4.16-15-4.64-.07,0-.06-.1,0-.11,2.7-.48,6.1.18,8.7.92a14.39,14.39,0,0,1,6.43,3.67C313,126.13,312.89,126.28,312.79,126.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.57,112.48c.17.09-.15.24,0,.34.7.4,4.71,3.23,4.17,4.89-.43,1.33-2.53,1.67-3.38,1.49l-2.15-.46,1.86,1.18a8.93,8.93,0,0,1,2.19,1.92,3.21,3.21,0,0,1,.83,2.49,1.82,1.82,0,0,1-1.64,1.63,5.52,5.52,0,0,1-2.74-.48l-2.41-1,1.94,1.72a8.47,8.47,0,0,1,1.42,1.62,3.44,3.44,0,0,1,.66,1.9,1.64,1.64,0,0,1-.91,1.48,3.63,3.63,0,0,1-2.05.06,29,29,0,0,1-4.29-1.4c-.71-.27-1.43-.54-2.16-.78a5.31,5.31,0,0,0-2.26-.35,5.8,5.8,0,0,1,2.19.55c.7.29,1.39.61,2.08.93a24.06,24.06,0,0,0,4.31,1.67,4.25,4.25,0,0,0,2.45,0,2.34,2.34,0,0,0,1.44-2.14,4.26,4.26,0,0,0-.76-2.37,9.34,9.34,0,0,0-1.55-1.83l-.47.72a6.33,6.33,0,0,0,3.24.6,2.64,2.64,0,0,0,1.62-.78,3,3,0,0,0,.76-1.61,4,4,0,0,0-1.05-3.16,9.91,9.91,0,0,0-2.44-2.08l-.29.72c1.09.2,3.47.07,4.4-1.91C319.43,115.29,314.51,112.86,313.57,112.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.49,112.52a5.37,5.37,0,0,0,1.62-.3,1.25,1.25,0,0,0,.84-.94,2.63,2.63,0,0,0-.33-1.4c-.25-.49-.53-1-.84-1.48a4.28,4.28,0,0,1,1.34,1.17,2.51,2.51,0,0,1,.57,1.83,1.85,1.85,0,0,1-.51.94,1.89,1.89,0,0,1-.91.44A2.89,2.89,0,0,1,313.49,112.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.19,120.19l-9,32.26s16.9,8.56,24.06,8.71,27.75-9.38,38.92-20.48c4.31-4.29,5-10.15-5.53-7.57s-25.05,5.54-26.15,5.32S328.19,120.19,328.19,120.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.28,125.57c-.81,2.26-1.4,4.62-2,6.93s-1.26,4.64-1.86,7c-1.18,4.66-2.24,9.36-3.26,14.06a.08.08,0,0,0,.15,0c1.37-4.62,2.69-9.25,3.89-13.91q.9-3.49,1.71-7c.54-2.34,1.16-4.69,1.53-7.06A.06.06,0,1,0,333.28,125.57Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.66,169.83l-2.35,24.43s41.23-1.43,51-2.6c0,0-11.88-44.87-23-55.82-5.56-5.47-11.74-4.74-15.49-.54-1,1.06-12.11,17.4-13.07,23.48C362.94,164.15,366.66,169.83,366.66,169.83Z",
    style: {
      fill: "#62CE71"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.3,102.16c1.3,1.91,11.1,6.55,16.22-1.82s-5.48-18.89-13.73-13C385.24,91.29,385.55,98.1,388.3,102.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.53,134.32c-.27.81-4.72,5.84-8.5,5.32-1.23-.18-.59-6.93-.59-6.93l-.06-.51-.93-7.14,8.69-4.52,1.25-.59s.13,2,.26,4.42c0,.12,0,.23,0,.35l0,.4.06,1.11c0,.29,0,.56,0,.86s0,.59,0,.89A45.93,45.93,0,0,1,387.53,134.32Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.65,124.37a14.43,14.43,0,0,1-9.27,7.83l-.93-7.14,8.69-4.52,1.25-.59S387.52,121.92,387.65,124.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,113c-2.28,12.42,4.9,15.19,7.58,15.68,2.43.44,10.76,1.64,14.32-10.47s-1.5-17.11-7-18.42S371.23,100.6,369,113Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.16,111.07A8.27,8.27,0,0,0,372,111a1.42,1.42,0,0,0,.87-.26.45.45,0,0,0,.06-.54,1.1,1.1,0,0,0-1.06-.38,1.63,1.63,0,0,0-1.09.46A.48.48,0,0,0,371.16,111.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.49,112.3c-.29-.07-.54-.18-.83-.28a1.39,1.39,0,0,1-.79-.44.44.44,0,0,1,.07-.54,1.12,1.12,0,0,1,1.12-.14,1.63,1.63,0,0,1,.95.69A.48.48,0,0,1,379.49,112.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.33,114.91s.06,0,.06.08c-.15.85-.17,1.85.56,2.24,0,0,0,0,0,0C377,117,377.06,115.69,377.33,114.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.21,114.12c1.39.09,1.12,2.85-.16,2.77S377.05,114.05,378.21,114.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.74,114.32c.23.18.44.48.73.54s.61-.2.86-.46c0,0,0,0,0,0,0,.53-.3,1-.87,1.07s-.85-.48-.93-1C378.55,114.39,378.65,114.25,378.74,114.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.6,114.13s-.07,0-.07.07c0,.86-.25,1.84-1,2,0,0,0,0,0,0C372.44,116.25,372.69,115,372.6,114.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.92,113.17c-1.37-.23-1.73,2.53-.46,2.74S373.06,113.36,371.92,113.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.32,113.28c-.24.11-.49.35-.75.34s-.49-.35-.64-.66c0,0,0,0-.05,0-.08.52,0,1.09.51,1.26s.85-.26,1-.77C371.47,113.39,371.41,113.23,371.32,113.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.87,121.56c-.21.19-.43.46-.75.47a2.27,2.27,0,0,1-.91-.26s0,0,0,0a1.17,1.17,0,0,0,1.07.52.91.91,0,0,0,.71-.72S376.9,121.54,376.87,121.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.63,118.09s-.31,1.25-.38,1.86c0,0,.14.1.34.13,0,0,0,0,0,0a2.87,2.87,0,0,0,2.89-.77c.05,0,0-.12-.08-.09a4.36,4.36,0,0,1-2.69.47c0-.17.61-2.14.51-2.16a5.14,5.14,0,0,0-1.4.17c.58-2.64,1.58-5.17,2.12-7.8a.09.09,0,0,0-.16-.06,44,44,0,0,0-2.63,8.3C372.09,118.48,373.38,118.16,373.63,118.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.69,119.62a3.45,3.45,0,0,0,1.14,1.38,1.58,1.58,0,0,0,.92.27c.72,0,.88-.64.88-1.21a4.3,4.3,0,0,0-.12-.88A4.61,4.61,0,0,1,373.69,119.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.83,121a1.58,1.58,0,0,0,.92.27c.72,0,.88-.64.88-1.21A1.64,1.64,0,0,0,374.83,121Z",
    style: {
      fill: "#ff9abb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.73,118.33A5.17,5.17,0,0,1,388,114a13.41,13.41,0,0,1-5.32-4.59c.08.26.62,2.14.92,3.09a13.88,13.88,0,0,1-10.11-7.9,13.62,13.62,0,0,0-3.63,4.91s.15-4.83,2.72-8c8.65-10.77,18.16.75,18.16.75s3.19,1.81,3.62,5C395.2,113.61,390.73,118.33,390.73,118.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.62,111a14.58,14.58,0,0,0,4,1.63s0,0,0,0a12.32,12.32,0,0,1-5.69-3.71,11.87,11.87,0,0,1-1.63-2.45,8,8,0,0,1-.95-3c0-.08-.12-.07-.12,0a9.63,9.63,0,0,0,.52,3.15,8.88,8.88,0,0,0,1.67,2.68,10.12,10.12,0,0,0,2.19,1.77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.7,117.73s3.12-3.66,4.8-2.51-.92,6.64-3.08,7.22a2.14,2.14,0,0,1-2.74-1.42Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.72,116.77s0,0,0,.06a5.41,5.41,0,0,0-3.1,3.1,1.19,1.19,0,0,1,1.79-.16s0,.09-.05.08a1.31,1.31,0,0,0-1.48.32,5.84,5.84,0,0,0-.8,1.1c-.08.12-.31,0-.25-.12l0,0C389,119.25,390.69,116.77,392.72,116.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.82,132.74s-3.49,16.92-1.44,40.3c3.86,44.09,14.8,109.23,17.43,113.55,4,6.63,45.94,10.89,45.94,10.89a941.26,941.26,0,0,0-32.63-108.79s-8.6-24.82-11.65-31.44C394,132.45,387.82,132.74,387.82,132.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.1,224.85a99.07,99.07,0,0,1-11.73,2.84c-5.55.9-11.16,1.25-12.75,1.48-.15,0-.14.5,0,.5,2.11-.07,8.59-.46,12.83-1.14a67.37,67.37,0,0,0,11.39-3c.17,1.18.31,2.1.5,3.27-3.79,1.39-11.14,3.92-23.61,4.32-.11-.49-.47-3.12-.69-3.82,0-.11-.49-.05-.48.12,0,.72.74,7.06.94,8.34.49,3.16,2.13,12,3.19,13.64,2.41,3.62,10,2.4,12.13,2.08s8.93-1.21,11.08-4.1c1.14-1.55.27-8.82-1-15.17C428.32,231.21,427.29,224.88,427.1,224.85Zm-7.84,27.77c-6.73,1.09-9.88.16-11.14-1.08-1.48-1.44-2-4.28-2.64-7.41-.47-2.46-1.63-10.22-1.67-10.38a63.55,63.55,0,0,0,23.62-4.13c.61,3.67,1.09,6.6,1.69,10.28.43,2.66,1,7.14-.12,8.91C428.08,250.29,424.12,251.83,419.26,252.62Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.33,227c1.25,3.64-.12,9.48,2.75,9.39,2.56-.08,3.11-4.22,3.11-4.22s.88,4.87,3.6,4,2.41-5.53,2.41-5.53.55,4.08,3.2,3,3.11-5.07,3.11-5.07,1,1.06,2.5-.53c2.2-2.28,1.26-9.06-.06-12.49s-8.73-15-9.9-16.73L405,207.16s-.44,7.18-.23,10.85,4.29,15.56,7.31,14.75,0-9.16-.29-11.37.17-2.65,1.07-1.75C413.45,220.22,415.78,225.36,416.33,227Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.12,232c.37-5.82-.48-8.43-3.23-13.46-.05-.1.08-.2.15-.11,3.14,4.69,4.67,7.81,3.36,13.6C422.34,232.26,422.1,232.22,422.12,232Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.13,230.86c-.15-6.07-1-8.91-3.54-14.39,0-.08.1-.15.14-.07,2.9,5.17,4.35,8.32,3.7,14.41C428.4,231.08,428.13,231.14,428.13,230.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.46,228.51c-.56-5.87-1.41-9-4.51-14a.11.11,0,1,1,.18-.12c3.66,4.8,4.74,8.73,4.51,14.12C434.62,228.84,434.5,228.88,434.46,228.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.57,139.91c13.08,17.75,30.27,55.23,32.52,61.23,1.53,4.06-21.66,12.31-22.29,9.39-.79-3.73-13.05-50.55-16.32-67.9C387.68,133.07,392.34,135.52,395.57,139.91Z",
    style: {
      fill: "#f7a9a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,204l27.14-6.79s-24.85-48.33-31.71-57.34c-7-9.16-8.26-4-7,5.82C390.86,156.29,401,204,401,204Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.45,194.26c-1.85.22-3.69.71-5.51,1.1s-3.66.8-5.48,1.22c-3.65.84-7.3,1.7-10.9,2.72a.08.08,0,0,0,0,.15c3.69-.64,7.35-1.46,11-2.3,1.79-.41,3.57-.84,5.35-1.27s3.75-.82,5.55-1.43A.1.1,0,0,0,424.45,194.26Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.92,203.26c-.51,0-2.58.23-2.66.26,0-.26-1.35-8.9-1.71-10.69-.7-3.5-1.45-7-2.18-10.49-1.49-7.07-3.07-14.12-4.61-21.18-.87-4-1.77-7.93-2.74-11.88,0-.09-.16-.05-.15.05.41,2.31.84,4.61,1.29,6.92-.43-1-.88-2-1.27-3,0-.09-.19,0-.15,0,.41,1,.76,2.11,1.14,3.16.2.56.42,1.11.65,1.65.82,4.17,1.68,8.33,2.53,12.49,1.44,7.08,2.86,14.17,4.42,21.23.43,1.94,2.31,12.3,2.38,12.28s2.65-.57,3.13-.77C404,203.35,404,203.25,403.92,203.26Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.15,134.06s-7.45,9.82-9.64,40.73c-2.37,33.35-7.43,105.61-7.82,108.17s-10.83,8.54-10.83,8.54l16.07-121.56s-3-6-2.46-10.41C364.13,153.65,375.27,135.37,378.15,134.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.3,144.74c-.75,1-1.42,2.17-2.08,3.29l.12-.4c.19-.58.34-1.18.48-1.78,0,0-.05-.06-.07,0-.21.58-.42,1.17-.58,1.76l-.3,1,0,0c-.4.66-1.68,3.47-2,4.14-.05.09.1.17.14.08.32-.69,1.91-3.34,2.26-4,.69-1.37,1.47-2.7,2.16-4.08A0,0,0,1,0,370.3,144.74Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.15,134.06q-3.69,4.81-7.43,9.59l0-.26,1.93,1.73.15.14-.14.16-4,4.54.06-.15c0,4.16,0,8.33,0,12.49s-.1,8.33-.21,12.49c-.12-4.16-.18-8.33-.22-12.49s-.05-8.33,0-12.49v-.09l.05-.07,4-4.51,0,.29-1.89-1.76-.13-.12.11-.14Q374.26,138.7,378.15,134.06Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.8,132.71q2,5.76,3.94,11.55l.07.2-.21,0-3.74.73L388,145l2.12,5.23,0,0v.07c-.53,4-1.14,8.1-1.72,12.14s-1.23,8.09-1.91,12.13q.69-6.1,1.49-12.18c.55-4.06,1.08-8.11,1.68-12.16l0,.12-2.08-5.24-.1-.25.26,0,3.75-.69-.15.25C390.16,140.5,389,136.6,387.8,132.71Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.45,
    y: 416.5,
    width: 117.26,
    height: 14.93,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.13,
    y: 387.42,
    width: 101.22,
    height: 14.93,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.75 443.08 326.15 443.08 335.02 402.35 352.5 402.35 334.75 443.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.03 402.34 352.5 402.34 348.06 412.53 332.81 412.53 335.03 402.34",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.75 443.08 433.35 443.08 424.47 402.35 406.99 402.35 424.75 443.08",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "426.69 412.53 411.43 412.53 406.99 402.34 424.47 402.34 426.69 412.53",
    style: {
      fill: "#37474f"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyChooseUsFirstPic);
export default __webpack_public_path__ + "static/media/why_choose_us_first_pic.7dab245514611dd9d140b377fa6243a9.svg";
export { ForwardRef as ReactComponent };